<template>
  <div :id="'chart_'+uuid">
    <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
      <canvas :id="uuid" :width="size.width" :height="size.height" />
    </div>
  </div>
</template>

<script>
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Colorize, palette  } from "@/libs/colorizer";

export default {
  name: "9e5d5835-e349-11ed-8761-c85acf022408",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      canvas: null,
      graph: null,
      objecto: null,
      status_list: [],
      sides_list: [],
      sidez: [],
      datasets: [],
      sides: ['Заказчик', 'Исполнитель']
    }
  },
  computed: {
    palette() {
      return palette
    },
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  methods: {
    Colorize,
    make_chart: function () {
      this.update_data()
      if (this.canvas) {
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ChartDataLabels],
          data: {
            labels: this.sidez,
            datasets: this.datasets,
          },
          options: {
            plugins: {
              legend: {
                position: 'top',
                align: 'center'
              },
              datalabels: {
                formatter: function (value) {
                  if (value > 0) return Math.ceil(value)
                  return null
                },
                color: function (value) {
                  return Colorize(value.dataset.backgroundColor)
                }
              },
              tooltip: {
                callbacks: {
                  title: function (value) {
                    let m = ['заказчика', 'исполнителя']
                    return 'Сторона ' + m[value[0].dataIndex];
                  }
                }
              }
            },
            scales: {
              x: {
                stacked: true,
                ticks: {
                  // Include a dollar sign in the ticks
                  callback: function(index) {
                    let m = ['Заказчик', 'Исполнитель']
                    return m[index];
                  }
                }
              },
              y: {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                  callback: function (value) { if (Number.isInteger(value)) { return value } },
                  stepSize: 1
                },
                title: {
                  display: true,
                  text: 'Кол-во обращений'
                },
              }
            }
          }
        })
        this.graph.data.datasets.push()
      }
    },
    update_data: function () {
      this.objecto = null
      this.status_list = []
      this.sides_list = []
      this.sidez = []
      this.datasets = []

      for (let i = 0; i < this.chart.report_data.length;i ++) {
        if (!this.sides_list.includes(this.chart.report_data[i]["Сторона"])) {
          this.sides_list.push(this.chart.report_data[i]["Сторона"])
          this.sidez.push({
            name: this.chart.report_data[i]["Сторона"],
            systems: []
          })
        }
      }

      this.objecto = this.sides_list
      let name_of_null = 'ОТСУТСТВУЕТ СТАТУС'
      for (let i = 0; i < this.chart.report_data.length;i ++) {
        if (!this.status_list.includes(this.chart.report_data[i]["СтатусПРЕДСТАВЛЕНИЕ"])){
          if (this.chart.report_data[i]["СтатусПРЕДСТАВЛЕНИЕ"] !== '') {
            this.status_list.push(this.chart.report_data[i]["СтатусПРЕДСТАВЛЕНИЕ"])
          } else {
            this.status_list.push(name_of_null)
          }
        }
      }

      for (let i = 0; i < this.chart.report_data.length; i ++) {
        let element = (this.chart.report_data[i]["СтатусПРЕДСТАВЛЕНИЕ"] !== '') ? this.chart.report_data[i]["СтатусПРЕДСТАВЛЕНИЕ"] : name_of_null
        if (this.sides_list.includes(this.chart.report_data[i]["Сторона"]) && this.status_list.includes(element)) {
          this.sidez[this.sides_list.indexOf(this.chart.report_data[i]["Сторона"])].systems.push({
            system_name: element,
            obrashens: this.chart.report_data[i]["Неисправности"]
          })
        }
      }

      let data = []
      for (let i = 0; i < this.status_list.length; i++) {
        let system_error_by_object = []
        for (let j = 0; j < this.sidez.length; j++) {
          system_error_by_object[j] = 0
        }
        data.push(system_error_by_object)
      }

      for (let i = 0; i < this.sidez.length; i++) {
        for (let j = 0; j < this.sidez[i].systems.length; j++) {
          data[this.status_list.indexOf(this.sidez[i].systems[j].system_name)][i] = this.sidez[i].systems[j].obrashens
        }
      }
      for (let i = 0; i < this.status_list.length; i++) {
        this.datasets.push(
            {
              label: this.status_list[i].slice(3,),
              data: data[i],
              maxBarThickness: 800,
            }
        )
      }
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    }
  }
}
</script>
